import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'seuFileSize',
})
export class FileSizePipe implements PipeTransform {
  public transform(value: number, format = 'MB'): string {
    let fileSize = value;
    switch (format) {
      case 'KB':
        fileSize = value / 1024;
        break;
      case 'MB':
        fileSize = value / (1024 * 1024);
        break;
      case 'GB':
        fileSize = value / (1024 * 1024 * 1024);
        break;
      default:
        break;
    }
    return `${fileSize.toFixed(2)} ${format}`;
  }
}
